import React, { FunctionComponent, PropsWithChildren, ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'
import omit from 'lodash.omit'

export { Button } from './components/Button'
export { Heading } from './components/Heading'
export { Logo } from './components/Logo'
export * from './components/Icons'
export * from './components/Layout'
export * from './components/Forms'
export * from './components/Typeahead'
export * from './components/Whisper'
export * from './components/Spinner'
export * from './components/TiaModal'
export * from './components/Tooltip'
export * from './components/Select'
export * from './components/AdminModal'
export * from './components/Blocks'
export * from './components/Stepper'

export * from './hooks/useConfirmation'
import { StylePropertyValue } from 'theme-ui'
import * as CSS from 'csstype'

import * as ThemeUI from 'theme-ui'

export type Color = StylePropertyValue<
    CSS.Property.Color | CSS.Property.BackgroundColor
>

export { getCSS } from './util'

export const ThemeProvider: FunctionComponent<
    React.PropsWithChildren<
        PropsWithChildren<{ theme: ThemeUI.Theme } & Record<string, unknown>>
    >
> = (
    props: { theme: ThemeUI.Theme; children?: ReactNode } & Record<
        string,
        unknown
    >
) => {
    return (
        <ThemeUI.ThemeProvider
            theme={props.theme}
            {...omit(props, ['theme', 'children'])}
        >
            {props.children}
        </ThemeUI.ThemeProvider>
    )
}

// // We know in the real world theme is always defined
// // This ensures TypeScript also knows that
export function useTiaUI() {
    const context = ThemeUI.useThemeUI()

    if (!context) {
        throw new Error(
            'Render components that useTiaUI inside the ThemeProvider.'
        )
    }

    return {
        ...context,
        // assumes you're using our ThemeProvider
        theme: context.theme as ThemeUI.Theme
    }
}

export const css = ThemeUI.css

export const TiaGlobalCSS = (props: { globalCSS?: string }) => {
    return (
        <Helmet>
            <style>{props.globalCSS || GlobalCSS}</style>
        </Helmet>
    )
}

export * from './re-exports'

export { defaultTheme } from './themes/default'
export { oldWidgetTheme } from './themes/oldWidgetTheme'

import { ButtonProps as ButtonPropsType } from './components/Button'
import { GlobalCSS } from './themes/default'
export type ButtonProps = ButtonPropsType
